import template from './form.html';
import { FormActions } from 'core/services/form';
import transaccionesI18N from 'i18n/transacciones/es.json';
import commonI18N from 'i18n/common/es.json';
import { rest } from 'core/api';
import { formatErrorMessage } from 'core/util';

export let TransaccionFormComponent = {
  templateUrl: template,
  selector: 'transaccionForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(transaccionesI18N).concat(Object.keys(commonI18N));


FormController.$inject = [
  '$state', '$scope', '$filter', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', 'BasicFactory', '$timeout', 'localStorageService', 'CustomModal'
];

function FormController($state, $scope, $filter, $ngRedux, ngNotify, $stateParams, Filter, BasicFactory, $timeout, localStorageService, CustomModal) {
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.doSubmit = doSubmit.bind(this);

  this.newDetalle = newDetalle.bind(this);
  this.deleteDetalle = deleteDetalle.bind(this);
  this.renderDescripcionFormaPago = renderDescripcionFormaPago.bind(this);

  this.renderCliente = renderCliente.bind(this);
  this.renderTipoComprobante = renderTipoComprobante.bind(this);
  this.renderFormaPago = renderFormaPago.bind(this);
  this.onSelectFormaPago = onSelectFormaPago.bind(this);

  this.updateTotales = updateTotales.bind(this);

  this.cancel = cancel.bind(this);

  const activoFilter = Filter.path('estado.value').eq('Activo');

  let unsubscribe;
  this.$onDestroy = () => {
    this.form();
    $ngRedux.dispatch(rest.actions.timbradosVigentes.reset());
    unsubscribe();
  };

  this.$onInit = () => {
    ngNotify.dismiss();
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

    if ($stateParams.tid) {
      this.title = this.translations['Retificación de Cobro de factura'];
      this.formEdit('transacciones', $stateParams.tid);
    } else {
      $state.go('home.cajas.uid.sesiones-cajas.eid.transacciones.list', { uid:  $stateParams.uid, eid: $stateParams.eid});
      return;
    }
    $ngRedux.dispatch(rest.actions.formasPago({ filter: JSON.stringify(activoFilter) }));
    $ngRedux.dispatch(rest.actions.marcasTarjetas({ filter: JSON.stringify(activoFilter) }));
    $ngRedux.dispatch(rest.actions.emisoresTarjetas({ filter: JSON.stringify(activoFilter) }));
    $ngRedux.dispatch(rest.actions.procesadorasTarjetas({ filter: JSON.stringify(activoFilter) }));

    $timeout(function() {
      $scope.$broadcast('init');
    }, 20);
  };


  this.localModel = {
    totalServicios: $filter('currency')(0, 'Gs.', 0),
    totalProductos: $filter('currency')(0, 'Gs.', 0),
    total: $filter('currency')(0, 'Gs.', 0),
    nuevoDetalle: {},
    totalDetalles: 0,
    vuelto: 0
  };

  this.submitted = false;

  function mapStateToThis(state) {
    this.handleStatus(state);

    this.model = state.form.model;

    if (!this.modelInit && this.model.id) {
      this.modelInit = true;
      this.localModel.totalTransaccion = $filter('currency')(this.model.ingreso, 'Gs.', 0);
      //this.localModel.timbradoDetalle = this.renderTipoComprobante(this.model.factura.timbradoDetalle);
      this.localModel.cliente = this.renderCliente(this.model.factura.cliente);
      this.localModel.detalles = this.model.detalles;
      this.localModel.totalDetalles = this.model.ingreso;
      this.localModel.restante = this.model.ingreso;
    }

    if (state.formasPago.data.length && !this.formaPagoDefault) {
      this.formaPagoDefault = state.formasPago.data.filter(v => v.formaDesembolso.value === 'Efectivo')[0];
      this.localModel.nuevoDetalle.formaPago = this.formaPagoDefault;
    }

    this.procesadorasTarjetas = state.procesadorasTarjetas.data;

    return {
      form: state.form,
      formasPago: state.formasPago.data,
      marcasTarjetas: state.marcasTarjetas.data,
      emisoresTarjetas: state.emisoresTarjetas.data
    };
  }



  /**
   * Función que se encarga de mostrar mensajes de error/exito en base al estado actual
   * 
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.facturas.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      this.cobrarFacturaNotify(state.form.created);
      $state.go('home.facturas.list');
    }
  }

  function doSubmit() {
    if (this.localModel.totalDetalles < this.model.ingreso) {
      ngNotify.set(this.translations['Total detalles no cubre la factura'], 'warn');
      return;
    }

    if (this.localModel.totalDetalles > this.model.ingreso) {
      ngNotify.set(this.translations['Total detalles sobrepasa la factura'], 'warn');
      return;
    }

    let pagos = Object.assign([], this.localModel.detalles);
    pagos.forEach(function(detalle) {
      delete detalle.id;
    });
    
    let payload = {
      pagos
    };

    let self = this;
    $ngRedux.dispatch(rest.actions.rectificarTransaccion({ id: this.model.id }, {
      body: JSON.stringify(payload)
    }, (err, data) => {
      if (!err && data.estado.value == 'Rectificada') {
        ngNotify.set(self.translations['Rectificada Correctamente'], 'success');
        $state.go('home.cajas.uid.sesiones-cajas.eid.transacciones.list');
      } else if (err) {
        ngNotify.set(formatErrorMessage(err.message), { type: 'error', html: true });
      }
    }));
  }

  function updateTotales() {
    let totalEfectivo = 0;
    let totalOtros = 0;

    this.localModel.detalles.forEach(function(detalle) {
      if (detalle.formaPago.formaDesembolso.value === 'Efectivo') {
        totalEfectivo += detalle.monto;
      } else {
        totalOtros += detalle.monto;
      }
    });

    this.localModel.totalDetalles = totalEfectivo + totalOtros;
    this.localModel.vuelto = this.localModel.totalDetalles - this.model.ingreso;
    this.localModel.restante = this.model.ingreso - this.localModel.totalDetalles;
  }

  this.filterProcesadora = filterProcesadora.bind(this);

  function filterProcesadora() {
    let formaPagoSeleccionadaId = this.localModel.nuevoDetalle.formaPago.id;
    this.procesadorasTarjetasFiltradas = this.procesadorasTarjetas.filter(v => v.formaPago && v.formaPago.id === formaPagoSeleccionadaId);
  }

  function onSelectFormaPago() {
    $scope.form.$setUntouched();
    if (this.localModel.nuevoDetalle.formaPago && this.localModel.nuevoDetalle.formaPago.formaDesembolso.value !== 'Efectivo') {
      this.localModel.nuevoDetalle.monto = this.localModel.restante;
      //this.localModel.nuevoDetalle.montoView = this.localModel.total;
    }

    if (this.localModel.nuevoDetalle.formaPago && (this.localModel.nuevoDetalle.formaPago.formaDesembolso.value !== 'Tarjeta de crédito' &&
        this.localModel.nuevoDetalle.formaPago.formaDesembolso.value !== 'Tarjeta de débito')) {
      this.localModel.nuevoDetalle.procesadoraTarjeta = null;
      this.localModel.nuevoDetalle.emisorTarjeta = null;
      this.localModel.nuevoDetalle.marcaTarjeta = null;
    } else if (this.localModel.nuevoDetalle.formaPago.formaDesembolso.value === 'Tarjeta de crédito' ||
      this.localModel.nuevoDetalle.formaPago.formaDesembolso.value === 'Tarjeta de débito') {
      this.localModel.nuevoDetalle.procesadoraTarjeta = null;
    }

    this.filterProcesadora();
    //  if (vm.localModel.nuevoDetalle.formaPago && vm.localModel.nuevoDetalle.formaPago.)
  }

  function newDetalle() {
    this.detalleSubmitted = true;
    $scope.form.importe.$setValidity('custom', true);
    $scope.form.importe.$setTouched();
    if (!$scope.form.$valid) {
      return;
    }

    if (this.localModel.nuevoDetalle.formaPago.formaDesembolso.value !== 'Efectivo' &&
      (this.localModel.nuevoDetalle.monto + this.localModel.totalDetalles) > this.localModel.totalFactura) {
      this.mostrarConceptoNoFacturado = true;
    }

    let detalle = Object.assign({}, this.localModel.nuevoDetalle);
    this.localModel.detalles.push(detalle);
    this.localModel.nuevoDetalle = {
      formaPago: this.formaPagoDefault
    };

    this.detalleSubmitted = false;
    this.updateTotales();
    this.localModel.nuevoDetalle.monto = this.localModel.restante;
    $scope.form.$setUntouched();
  }

  function deleteDetalle(detalle) {
    _.remove(this.localModel.detalles, detalle);
    this.localModel.nuevoDetalle = detalle;
    this.updateTotales();
    this.filterProcesadora();
  }

  function renderDescripcionFormaPago(detalle) {
    let descripcion = detalle.formaPago.descripcion;
    if (detalle.formaPago.formaDesembolso.value === 'Tarjeta de crédito' || detalle.formaPago.formaDesembolso.value === 'Tarjeta de débito') {
      descripcion += ` (${detalle.formaPago.formaDesembolso.name}/${detalle.procesadoraTarjeta.nombre}${detalle.emisorTarjeta ? '/' + detalle.emisorTarjeta.nombre: ''}${detalle.marcaTarjeta ? '/' + detalle.marcaTarjeta.nombre: ''}/${detalle.numeroVoucher})`;
    } else if (detalle.formaPago.formaDesembolso.value === 'Cheque') {
      descripcion += ` (${detalle.formaPago.formaDesembolso.name}${detalle.chequeEntidadBancaria ? '/' + detalle.chequeEntidadBancaria: ''}/${detalle.chequeNumero}${detalle.chequeNumeroCuenta ? '/' + detalle.chequeNumeroCuenta : ''})`;
    } else if (detalle.formaPago.formaDesembolso.value === 'Efectivo') {
      descripcion += ` (${detalle.formaPago.formaDesembolso.name})`;
    }
    return descripcion;
  }

  function renderFormaPago(formaPago) {
    return `${formaPago.descripcion} (${formaPago.formaDesembolso.name})`;
  }

  function renderTipoComprobante(timbradoDetalle) {
    return `${timbradoDetalle.tipoComprobante.nombre} (${timbradoDetalle.tipoComprobante.clase.name} / ${timbradoDetalle.cabecera.claseTimbrado.name} )`;
  }

  function renderCliente(cliente) {
    let numeroDoc = cliente.numeroDocumento ? cliente.numeroDocumento : 'Sin Nro. Documento';
    return `${cliente.razonSocial} (${numeroDoc})`;
  }

  function cancel() {
    $state.go('home.cajas.uid.sesiones-cajas.eid.transacciones.list');
  }

  this.loadTipoFondoFijos = loadTipoFondoFijos.bind(this);


  function loadTipoFondoFijos(query) {
    let filter = Filter.path('tipoMovimiento.value').eq('Concepto no Facturado');

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query));
    }

    BasicFactory.setup('tipos-movimientos-fondos-fijos');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  this.renderTipoFondoFijo = renderTipoFondoFijo.bind(this);


  function renderTipoFondoFijo(tipoFondoFijo) {
    return `${tipoFondoFijo.nombre}`;
  }


}


// WEBPACK FOOTER //
// ./src/components/cajas/sesiones-cajas/transacciones/form/form.component.js